import React from 'react';
import { CargoContractStatusTypes } from '@shared/utils/constants';
import { Port } from '@api/utils/ports';
import { CargoDetails } from '@api/features/cargos/getCargoDetails';
import CargoMarkersLayer from './CargoMarkersLayer';
import cargoLayerConfig from './cargoLayerConfig';
import ClusteredCargoMapLayer from './ClusteredCargoMapLayer';

type CargoMapLayersProps = {
	cargos?: CargoDetails[];
	showTentativeBookings?: boolean;
	showContractedCargos?: boolean;
	selectedLoadingPortId: number | null;
	onLoadingPortClick: (port: Port) => void;
	zoom?: number;
};

const CargoMapLayers = ({
	cargos,
	showTentativeBookings,
	showContractedCargos,
	selectedLoadingPortId,
	onLoadingPortClick,
	zoom,
}: CargoMapLayersProps) => {
	const showClusters = zoom == null || zoom < 6;

	if (showClusters) {
		return (
			<ClusteredCargoMapLayer
				cargos={cargos}
				showTentativeBookings={showTentativeBookings}
				showContractedCargos={showContractedCargos}
				selectedLoadingPortId={selectedLoadingPortId}
			/>
		);
	}

	return (
		<>
			{cargoLayerConfig.map(({ status, renderMarker }) => {
				const isVisible =
					status === CargoContractStatusTypes.TentativeBooking ?
						showTentativeBookings :
						showContractedCargos;

				if (!isVisible) {
					return null;
				}

				const filtered = cargos?.filter((c) => (
					c.contractStatus === status
				)) ?? [];

				return (
					<CargoMarkersLayer
						key={status}
						cargos={filtered}
						selectedLoadingPortId={selectedLoadingPortId}
						renderMarker={(port, isSelected) => (
							renderMarker(port, onLoadingPortClick, isSelected)
						)}
					/>
				);
			})}
		</>
	);
};

export default CargoMapLayers;